import { useMemo } from 'react';
import { useGate } from 'statsig-react';

export const useStatsigGate = name => {
  const { value, isLoading } = useGate(name);

  return useMemo(() => !isLoading && value, [isLoading, value]);
};
